import { Space } from 'antd';
import { AntRow } from 'components/ant/AntRow';
import { Notice } from 'components/UI/Notice/styled';
import { observer } from 'mobx-react-lite';
import React from 'react';

interface Props {
  title: React.ReactNode;
  toggle?: React.ReactNode;
  notice?: React.ReactNode;
}

const stopPropagation = (e: React.MouseEvent) => e.stopPropagation();

const CollapseHeader = observer<Props>(({ title, notice, toggle }) => (
  <AntRow justify="space-between">
    <b>{title}</b>

    <Space>
      {toggle}

      {notice && <Notice onClick={stopPropagation}>{notice}</Notice>}
    </Space>
  </AntRow>
));

export default CollapseHeader;
